import { Container } from '@mui/material'
import ProjectBreadcrumb from '@/components/project-tables/ProjectBreadcrumb'
import PositionList from './PositionList'

export default function PositionsPage() {
  return (
    <Container maxWidth="md">
      <ProjectBreadcrumb label="Positions" url="../positions" />

      <PositionList />
    </Container>
  )
}
